import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from './LoadingFeedback';

export default function ProtectedRoute({ children }) {
  const { user, loading, authError } = useAuth();

  if (loading) {
    return <PageLoader label="Opening your workspace…" fullScreen />;
  }

  if (!user) {
    const reason = authError?.code === "INVITE_REQUIRED" ? "?reason=invite_required" : "";
    return <Navigate to={`/login${reason}`} replace />;
  }
  return children;
}
